import React from 'react';
import { Typography } from '@mui/material';
import { FaGithub, FaLinkedin } from 'react-icons/fa';
import { useTheme } from '@mui/material/styles';
import { FooterWrapper, ContentWrapper, SocialIcons, SocialIcon, FooterDivider } from '../styles/FooterStyles';
import { useFooter } from '../utils/FooterUtils';

const FooterComp = () => {
  const theme = useTheme();
  const { name, description, copyright, githubUrl, linkedinUrl } = useFooter();

  return (
    <FooterWrapper>
      <ContentWrapper maxWidth="lg">
        <Typography variant="h6" fontWeight="bold" sx={{ mb: 2, color: theme.palette.mode === 'dark' ? '#BB86FC' : '#6A5ACD' }}>
          {name}
        </Typography>
        <Typography variant="body2" color={theme.palette.mode === 'dark' ? '#A0A0A0' : 'textSecondary'} align="center" sx={{ maxWidth: '600px', mb: 3 }}>
          {description}
        </Typography>
        <SocialIcons>
          <SocialIcon href={githubUrl} aria-label="GitHub">
            <FaGithub size={24} />
          </SocialIcon>
          <SocialIcon href={linkedinUrl} aria-label="LinkedIn">
            <FaLinkedin size={24} />
          </SocialIcon>        
        </SocialIcons>
        <FooterDivider />
        <Typography variant="body2" color={theme.palette.mode === 'dark' ? '#808080' : 'textSecondary'}>
          &copy; {copyright}
        </Typography>
      </ContentWrapper>
    </FooterWrapper>
  );
};

export default FooterComp;
